import * as React from "react";
const SvgExit = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.853997 0V1.4213H5.56321L0 7.10648L0.854059 8L6.5708 2.42331V7.10648H8V0H0.853997Z", fill: "black" }));
export default SvgExit;
